import './Library.css'
import axios from 'axios'
import { useState, useEffect, useContext } from 'react'
import AuthContext from '../../contexts/AuthContext'
import { Center, Loader, SimpleGrid, Stack } from '@mantine/core'
import MainLayout from '../../layouts/MainLayout/MainLayout'
import LibraryContentCard from '../../features/Library/LibraryContentCard'
import UserSubscriptionCard from '../../features/Library/UserSubscriptionCard/UserSubscriptionCard'
import LibraryContentFilters from '../../features/Library/LibraryContentFilters'
import { useNavigate, useSearchParams } from 'react-router-dom'



export default function Library() {
   const { authToken } = useContext(AuthContext)
   const [content, setContent] = useState(null)
   const navigate = useNavigate()
   const [searchParams] = useSearchParams();
   const search = searchParams.get("search")?.toLowerCase() || "";
   const specialty = decodeURIComponent(searchParams.get("specialty") || "").replace(/\+/g, " ");
   
   const [loading, setLoading] = useState({
      isContentPending: false,
      isVisitPending: false,
      isDownloadPending: false
   })

   useEffect(() => {
      const getAllContent = async () => {
         try {
            setLoading(prev => ({ ...prev, isContentPending: true }))

            const { data } = await axios.get(
               `${process.env.REACT_APP_BACKEND_SERVER}campus/library`,
               {
                  headers: {
                     "Content-Type": "application/json",
                     Authorization: `Bearer ${authToken}`,
                  },
               }
            );

            setContent(data)

         } catch (error) {
            console.log(error)
         } finally {
            setLoading(prev => ({ ...prev, isContentPending: false }))
         }
      }

      getAllContent()
   }, [authToken])

  

   const handleClickCard = async (item) => {
      if (!item) return null
      navigate(`/campus/biblioteca/${item._id}`)
   }

   const mostDownloaded = content?.sort((a, b) => b.downloads - a.downloads).slice(0, 3)
   const mostViewed = content?.sort((a, b) => b.views - a.views).slice(0, 3)

   if (loading.isContentPending) return <MainLayout>
      <Center mih={'100vh'}><Loader /></Center>
   </MainLayout>

   if (content) {
      return (
         <MainLayout>

            <section className='LibraryPage-main-container'>
               <h1 className='LibraryPage-main--title'>Biblioteca de contenido</h1>

               <UserSubscriptionCard  />

               <LibraryContentFilters />

               {search || specialty
                  ? <Stack w='100%' align='start'>
                     <h2 className='LibraryPage-title-section'>Resultados de la búsqueda</h2>
                     <div className='Library-info-wrapper'>

                        <SimpleGrid cols={{ base: 1, xs: 2, sm: 3 }}>
                           {(content && content?.length > 0) &&
                              content
                                 ?.filter(item =>
                                    (item.title?.toLowerCase().includes(search?.toLowerCase()) ||
                                       item.author?.toLowerCase().includes(search?.toLowerCase())) &&
                                    (specialty
                                       ? item.tags?.some(tag =>
                                          typeof tag?.name === 'string' &&
                                          tag?.name?.toLowerCase()?.trim() === specialty?.toLowerCase()?.trim()
                                       )
                                       : true)
                                 )
                                 ?.map(item => (
                                    <LibraryContentCard
                                       handleClik={handleClickCard}
                                       content={item}
                                       key={item._id}
                                    />
                                 ))}
                        </SimpleGrid>
                     </div>
                  </Stack>
                  : <>
                     <Stack w='100%' align='start'>
                        <h2 className='LibraryPage-title-section'>Contenido más visto</h2>
                        <div className='Library-info-wrapper'>

                           <SimpleGrid cols={{ base: 1, xs: 2, sm: 3 }}>
                              {(mostDownloaded && mostDownloaded?.length > 0) && mostDownloaded?.map(item => (
                                 <LibraryContentCard
                                    handleClik={handleClickCard}
                                    content={item}
                                    key={item._id} />
                              ))}
                           </SimpleGrid>
                        </div>
                     </Stack>

                     <Stack w='100%' align='start'>
                        <h2 className='LibraryPage-title-section'>En tendencia</h2>
                        <div className='Library-info-wrapper'>

                           <SimpleGrid cols={{ base: 1, xs: 2, sm: 3 }}>
                              {(mostViewed && mostViewed?.length > 0) && mostViewed?.map(item => (
                                 <LibraryContentCard
                                    handleClik={handleClickCard}
                                    content={item}
                                    key={item._id} />
                              ))}
                           </SimpleGrid>
                        </div>
                     </Stack>


                     <Stack w='100%' align='start'>
                        <h2 className='LibraryPage-title-section'>Explorá todo el contenido</h2>
                        <div className='Library-info-wrapper'>

                           <SimpleGrid cols={{ base: 1, xs: 2, sm: 3 }}>
                              {(content && content?.length > 0) && content.sort((a, b) => a.downloads - b.downloads)?.map(item => (
                                 <LibraryContentCard
                                    handleClik={handleClickCard}
                                    content={item}
                                    key={item._id} />
                              ))}
                           </SimpleGrid>
                        </div>
                     </Stack>
                  </>
               }
            </section>
         </MainLayout>
      )
   }
}
